import React, { useEffect, useState } from "react";
import Header from "../../../components/Header/Header";
import {
  Grid,
  Card,
  Breadcrumbs,
  Typography,
  CircularProgress,
} from "@material-ui/core";
import HeaderLinks from "../../../components/Header/HeaderLinks";
import classNames from "classnames";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-kit-react/views/profilePage.js";
import { darkBlueColor, whiteColor, apiUrl } from "../../../Utils/index";
import Footer from "components/Footer/Footer";

const axios = require("axios");
const useStyles = makeStyles(styles);

export default function Assignment(props) {
    const history = useHistory();
  const classes = useStyles();
  const { ...rest } = props;

  const [assignmentData, setAssignmentData] = useState([]);
  const [assignmentLoading, setAssignmentLoading] = useState(false);
  const [courseName, setCourseName] = useState("Course");

  useEffect(() => {
    setAssignmentLoading(true);
    let courseId = window.location.pathname.toUpperCase();

    if(courseId){
    window.scrollTo(0, 0);
        axios({
        method: "GET",
        url: apiUrl + "/assignment",
        headers: {
            "Content-Type": "application/json",
        },
        })
        .then((res) => {
            let data = res.data.filter((val) => "/ASSIGNMENT/" + val.courseId == courseId)
            setAssignmentData(data);
            setCourseName(data[0].courseId);
            setAssignmentLoading(false);
        })
        .catch((error) => {
            console.log("Error", error);
        });
    }
  }, []);

  console.log("courseName", courseName);

  return (
    <div>
        <Header
            color="white"
            rightLinks={<HeaderLinks />}
            fixed
            changeColorOnScroll={{
            height: 200,
            color: whiteColor,
            }}
            {...rest}
        />
        <div
            className={classNames(classes.main)}
            style={{ marginTop: 110, backgroundColor: whiteColor }}
        >
            <div>
                    <div className={classes.container} style={{ padding: 30 }}>
                    {assignmentLoading ? 
                        null 
                        :
                        <div>
                            <h2
                                style={{
                                    fontSize: "30px",
                                    fontFamily: "Rubik, sans-serif",
                                    fontWeight: "bold",
                                    color: darkBlueColor,
                                    marginBottom: 20,
                                }}
                            >
                                {courseName}
                            </h2>

                            <Breadcrumbs aria-label="breadcrumb">
                                <Typography style={{ cursor: 'pointer' }} onClick={()=> history.goBack()} >
                                    Assignments
                                </Typography>
                                <Typography color="text.primary">{courseName}</Typography>
                            </Breadcrumbs>
                        </div>
                    }

                        {assignmentLoading ? 
                            <div className={classes.container} style={{ textAlign: 'center', marginBottom: 200, marginTop: 200 }}>
                                <CircularProgress /> 
                            </div>
                            :
                            <div style={{ marginTop: 20 }}>
                                <Grid
                                    container
                                    spacing={2}
                                    style={{ marginBottom: 20 }}
                                >
                                    {assignmentData && assignmentData.length > 0 ? 
                                        assignmentData?.map((value, index) => {
                                        return(
                                            <Grid key={index} item xs={12} sm={12} md={12} lg={12}>
                                                <a
                                                    target="_blank"
                                                    href={apiUrl + "/download/" + value.pdf}
                                                >
                                                    <Card
                                                        style={{
                                                            borderRadius: 10,
                                                            paddingLeft: 20,
                                                            paddingBottom: 10,
                                                            // padding: 30,
                                                            backgroundColor: darkBlueColor,
                                                        }}
                                                    >
                                                        <h2
                                                            style={{
                                                                fontSize: 16,
                                                                fontWeight: 'bold',
                                                                fontFamily: "Rubik, sans-serif",
                                                                color: whiteColor,
                                                            }}
                                                        >
                                                        {value.title}
                                                        </h2>
                                                    </Card>
                                                </a>
                                            </Grid>
                                        )
                                    })  :
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <h2
                                            style={{
                                                fontSize: "30px",
                                                fontFamily: "Rubik, sans-serif",
                                                fontWeight: "bold",
                                                color: darkBlueColor,
                                                marginTop: 100,
                                                marginBottom: 200,
                                            }}
                                        >
                                            No Data
                                        </h2>
                                    </Grid>
                                    } 
                                </Grid>
                            </div>
                        }
                    </div>
            </div>
        </div>
      <Footer />
    </div>
  )
}